import { Button } from '@/components/ui/button'

type OrganizationCompanyPageHeaderProps = {
  title: string
  description: string
  updateCertificateLabel: string
  onOpenCertificate: () => void
}

export function OrganizationCompanyPageHeader({
  title,
  description,
  updateCertificateLabel,
  onOpenCertificate,
}: OrganizationCompanyPageHeaderProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
        <p className="text-muted-foreground">{description}</p>
      </div>
      <Button type="button" variant="outline" onClick={onOpenCertificate}>
        {updateCertificateLabel}
      </Button>
    </div>
  )
}
